<template>
  <v-row  v-on:click="toggleCard()">

      <transition name="flip">
        <v-col v-bind:key="data.flipped">
          <section v-if="!data.flipped" class="card card-front">
            <section class="section-image" :style="sectionStyle">
              <v-img
                v-bind:src="url_photo"
                class="img-photo"
                fixed
              >
              </v-img>
            </section>
            <section class="section-title pl-2 pr-2">
              <h3 style="font-weight: 300;" class="text-uppercase">{{ data.name }}</h3>
            </section>

            <section class="section-flag">
              <v-img
                v-bind:src="url_flag"
                class="img-flag"
                fixed
              >
              </v-img>
            </section>

            <section class="pl-2 pr-2 section-position">
              <h5 class="text--secondary font-weight-light">{{ data.last_position }}</h5>
            </section>

            <section class="section-social">
              <a v-if="data.web" :href="data.web" target="_blank">
                <v-icon>
                  mdi-web
                </v-icon>
              </a>

              <a v-if="data.linkedin" :href="data.linkedin" target="_blank">
                <v-icon>
                  mdi-linkedin
                </v-icon>
              </a>
              
              <a v-if="data.facebook" :href="data.facebook" target="_blank">
                <v-icon>
                  mdi-facebook
                </v-icon>
              </a>
              
              <a v-if="data.instagram" :href="data.instagram" target="_blank">
                <v-icon>
                  mdi-instagram
                </v-icon>
              </a>

              <a v-if="data.twitter" :href="data.twitter" target="_blank">
                <v-icon>
                  mdi-twitter
                </v-icon>
              </a>

              <a v-if="data.youtube" :href="data.youtube" target="_blank">
                <v-icon>
                  mdi-youtube
                </v-icon>
              </a>

              <a v-if="data.whatsapp" :href="data.whatsapp" target="_blank">
                <v-icon>
                  mdi-whatsapp
                </v-icon>
              </a>

              <a v-if="data.email" :href="'mailto:'+data.email" target="_blank">
                <v-icon>
                  mdi-email
                </v-icon>
              </a>
            </section>
            
          </section>

          <section v-if="data.flipped" class="card card-back overflow-auto">
            <p class="text--secondary card-description" v-if="data.description.length < 400">
              {{ data.description }}
            </p>
            <p class="text--secondary card-description-large" v-if="data.description.length >= 400">
              {{ data.description }}
            </p>
          </section>  
        </v-col>
      </transition>

  </v-row>
</template>
<script>
  const APP_URL = process.env.VUE_APP_URL

  export default {
    name: 'cardPerson',
    props:['data', 'backgroundCard'],

    data: () => ({
      show_card:false,
      loading:false,
      flipped: false,
      newFront: '',
      newBack: '',
      error: false,

      url_photo:null,
      base_url: null
    }),
    computed: {
      sectionStyle() {
        return {
          backgroundImage: `linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.9)), url(${this.backgroundCard})`
        }
      }
    },
    methods:{    
      createURL(){
        this.url_photo = this.base_url + this.data.photo
        this.url_flag = this.base_url + this.data.country.flag
        this.show_card = true
      },

      toggleCard: function() {
        this.data.flipped = !this.data.flipped;
      }
    },
    created() {
      this.base_url = APP_URL
      this.createURL()
    }
  }
</script>

<style type='text/css' scoped>
.card {
  outline: 1px solid #E0E0E0;
  height: 350px;
  width: 240px!important;
  cursor: pointer;
  background-color: #ffffff;
  border-radius: 8px;
  line-height: 27px;
  position: relative;
  color: #000000;
  box-shadow: 0 0 15px rgb(0 0 0 / 0.2);
}
.card-front {
  display: block;
  text-align: center;
  font-weight: 300;
  font-size: 18px;
}
.card-back {
  text-align: center; /* Centra el contenido horizontalmente */
  font-weight: 400;
  font-size: 13px;
  padding-top: 22px;
  padding-bottom: 22px;
  padding-left: 10px;
  padding-right: 10px;
}
.card-description {
  line-height: 1.5; 
  justify-content: center;
  align-items: center;
}

.card-description-large {
  line-height: 1.5; 
  justify-content: left!important;
  align-items: top!important;
}
.img-photo {
  max-height: 116px;
  max-width: 116px;
  min-height: 116px;
  min-width: 116px;
  border-radius: 50%; 
}

.img-flag{
  height: auto;
  max-width: 32px;
}

.section-image {
  display: flex;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  justify-content: center;
  align-items: center;
  height: 140px;
  background-size: contain;
  background-repeat: repeat;
  background-position: center;
}

.section-title {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
}

.section-flag {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
}

.section-position {
  align-content: center;
  font-size: 20px;
  display: -webkit-box;  /* Necesario para usar -webkit-line-clamp */
  -webkit-box-orient: vertical;  /* Orientación vertical */
  overflow: hidden;  /* Oculta el texto desbordado */
  text-overflow: ellipsis;  /* Añade "..." al final del texto desbordado */
  -webkit-line-clamp: 3;  /* Número de líneas que quieres mostrar */
  line-clamp: 3;  /* Propiedad estándar para compatibilidad futura */
  line-height: 1.1em;  /* Ajusta esta propiedad según el espacio entre líneas */
  max-height: 3.1em;  /* 3 * line-height */
  height: 94px; /* Auto height for the content */
  margin-top: 12px;
  margin-bottom: 12px;
}

.section-social {
  margin-top: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
}

li:hover{
  transform: scale(1.02);
}

.flip-enter-active {
  transition: all .9s ease;
}

.flip-leave-active {
  display: none;
}

.flip-enter, .flip-leave {
  transform: rotateY(180deg);
  opacity: 0;

}

/* Form */
.flashcard-form{
  position: relative;
}


label{
  font-weight: 400;
  color: #333;
  margin-right: 10px;
}

input{
  border-radius: 5px;
  border: 2px solid #eaeaea;
  padding: 10px;
  outline: none;
}

button{
  border-radius: 5px;
  border: 1px solid #87cb84;
  background-color: #87cb84;
  padding: 8px 15px;
  outline: none;
  font-size: 14px;
  font-weight: 700;
  color: #fff;
  cursor: pointer;
  transition: all 0.3s ease;
}

button:hover{
  background-color: #70a66f;
}

.error{
  margin-top: 10px;
  display: block;
  color: #e44e42;
  font-weight: 600;
}
</style>